// 请求头token
export const TokenPre = 'Bearer ';
// export const AuthKey = 'Authorization';
export const AuthKey = 'token';

export const IsNightKey = 'IsNightKey';
export const ThemeOptionsKey = 'ThemeOptionsKey';

// 菜单为左侧模式时，最少出现抽屉宽度
export const SideCollapsedMaxWidth = 700;
export const TopCollapsedMaxWidth = 1270;

// 潜明本地
// export const apiUrlHPTFile = 'http://192.168.10.75:8201/hongan-project-qmsk';
// export const apiUrl = 'http://192.168.10.75:8201/hongan-project-qmsk';
// export const apiUrlHT = 'http://192.168.10.75:8201/hongan-project-qmsk';
// export const apiUrlHPT = 'http://192.168.10.75:8201/hongan-project-qmsk';

// export const apiUrl = 'http://192.168.10.15:8201/hongan-project-qmsk';
// export const apiUrlHT = 'http://192.168.10.15:8201/hongan-project-qmsk';
// export const apiUrlHPT = 'http://192.168.10.15:8201/hongan-project-qmsk';
// export const apiUrlHPTFile = 'http://192.168.10.15:8201/hongan-project-qmsk';

// 在线查看文件
export const apiUrlFile = 'http://120.199.186.148:19319/onlinePreview?url=';
// 潜明线上
export const apiUrl = 'http://120.199.186.148:19312/hongan-project-qmsk';
// export const apiUrl = 'http://39.170.9.52:8203/hongan-project-qmsk'
export const apiUrlHT = 'http://120.199.186.148:19312/hongan-project-qmsk';
export const apiUrlHPT = 'http://120.199.186.148:19312/hongan-project-qmsk';
export const apiUrlHPTFile = 'http://120.199.186.148:19312/hongan-project-qmsk';





// 后端人员本地的接口地址，后期改掉
// export const LocalHostUrlHT = 'http://192.168.10.75:8201/hongan-haining';
// export const LocalHostUrlHPT = 'http://192.168.10.75:8201/hongan-project-haining';
// 蔡枝彤
// export const LocalHostUrlHT = 'http://192.168.10.15:8201/hongan-tpsk';

// 之前.net后台可以自动获取租户id，但Java不可以直接获取，我们要自己传递租户id(某些接口需要)
export const TenantId = '1';

// export const systemTitle: any = '宁波原水巡查管理系统';
// export const systemTitle: any = '龙宫洞巡查管理系统';
export const systemTitle: any = '潜明水库标准化运行管理平台';

